import React, {ReactNode} from 'react'
import tw from 'tailwind-styled-components'
import {Icon} from '@components/common/base/icon'
import {TablerIcons} from '@components/common/icon-tabler/icon-tabler'
import {Tooltip} from '@components/common/tooltip/tooltip'
import {extensionItemDefaultTooltipOffset} from '@components/extensions-gallery/constants'

const TwStatItem = tw.div`
  flex
  align-center
  gap-4
  text-sm-regular
  text-secondary
  cursor-default
`

type ExtensionStatItemProps = {
  icon: TablerIcons | ReactNode
  value: ReactNode
  tooltipContent?: ReactNode
}

export const ExtensionStatItem = (props: ExtensionStatItemProps) => {
  const {icon, value, tooltipContent} = props

  const component = (
    <TwStatItem>
      <Icon icon={icon} />
      {value}
    </TwStatItem>
  )

  if (tooltipContent) {
    return (
      <Tooltip
        content={tooltipContent}
        offset={extensionItemDefaultTooltipOffset}
      >
        {component}
      </Tooltip>
    )
  }

  return component
}
